import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Checkbox } from '@one-thd/sui-atomic-components';
import { Add, Subtract } from '@one-thd/sui-icons';

const FILTER_ITEM_HEIGHT = 40;
const DROPDOWN_PADDING = 10;

const Dropdown = forwardRef(function Content(props, ref) {
  const {
    filters, selectedFilters, lengthLimit, onChange, isMobile
  } = props;
  const [seeAll, setSeeAll] = useState(false);
  const showSeeAll = isMobile && lengthLimit > 0 && filters.length > lengthLimit;
  const _filters = showSeeAll && !seeAll ? filters.slice(0, lengthLimit) : filters;

  const fixedHeightStyle = !isMobile
    && filters.length > lengthLimit && {
    height: `${(lengthLimit - 0.5) * FILTER_ITEM_HEIGHT - DROPDOWN_PADDING}px`,
    overflow: 'auto'
  };

  const handleOnClick = (event) => {
    event.preventDefault();
    setSeeAll(!seeAll);
  };

  const handleOnClickMenuItem = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const val = event.currentTarget?.getAttribute('data-value');
    onChange(val);
  };

  return (
    <div
      ref={ref}
      data-testid="filter-dropdown"
      style={{
        ...fixedHeightStyle
      }}
    >
      {_filters.map((filter) => {
        const isChecked = (selectedFilters || []).findIndex((ft) => ft === filter) > -1;
        return (
          <MenuItem
            onClick={handleOnClickMenuItem}
            key={filter}
            data-value={filter}
            selected={isChecked}
          >
            <>
              <Checkbox className="sui-self-start" checked={isChecked} id={filter} />
              <span className="sui-pl-1">{filter}</span>
            </>
          </MenuItem>
        );
      })}
      {showSeeAll && (
        <MenuItem onClick={handleOnClick}>
          <div
            className="sui-btn sui-justify-center sui-border-solid
          sui-border-1 sui-border-strong sui-rounded-base sui-w-full"
            data-testid="see-all"
          >
            {seeAll ? <Subtract /> : <Add />}
            <span className="sui-pl-2">{!seeAll ? 'View All' : 'View Less'}</span>
          </div>
        </MenuItem>
      )}
    </div>
  );
});

Dropdown.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedFilters: PropTypes.arrayOf(PropTypes.string),
  lengthLimit: PropTypes.number,
  isMobile: PropTypes.bool
};

Dropdown.defaultProps = {
  selectedFilters: [],
  lengthLimit: 0,
  isMobile: false
};

export default Dropdown;
